import * as BS from '@browser-search/browser-search';
import { buildIndexValuesCache, buildQueryCache } from './queryCache';
import { buildSubscriber } from './subscriber';
export const buildQueryClient = () => {
    const queryCache = buildQueryCache();
    const indexValuesCache = buildIndexValuesCache();
    const subscriber = buildSubscriber();
    const mutateStore = (mutationFunction) => (storeId) => (mutationFunction(storeId)
        .then(result => {
        [queryCache, indexValuesCache].forEach(cache => cache.deleteStoreCache(storeId));
        subscriber.notifyStoreChange(storeId);
        return result;
    }));
    const queryStore = (request) => {
        const maybeCachedSearchResponsePromise = queryCache.queryCache(request);
        return (maybeCachedSearchResponsePromise.caseOf({
            Just: searchResponse => [searchResponse, () => { }],
            Nothing: () => {
                const [searchResponsePromise, abort] = BS.queryStore(request);
                queryCache.addQueryToCache(request, searchResponsePromise);
                return [searchResponsePromise, abort];
            }
        }));
    };
    const queryIndex = (request) => {
        const maybeCachedResponsePromise = indexValuesCache.queryCache(request);
        return (maybeCachedResponsePromise.caseOf({
            Just: indexValues => indexValues,
            Nothing: () => {
                const indexValuesPromise = BS.getIndexValues(request);
                indexValuesCache.addQueryToCache(request, indexValuesPromise);
                return indexValuesPromise;
            }
        }));
    };
    const createStore = BS.createStore;
    const deleteStore = mutateStore((storeId) => BS.deleteStore({ storeId }));
    const addDocumentsToStore = (request) => mutateStore((_) => BS.addDocumentsToStore(request))(request.storeId);
    const subscribeToStoreChange = subscriber.addStoreListener;
    const unsubscribeToStoreChange = subscriber.removeStoreListener;
    return {
        queryStore,
        queryIndex,
        createStore,
        deleteStore,
        addDocumentsToStore,
        subscribeToStoreChange,
        unsubscribeToStoreChange,
    };
};
